import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { IChangeItemDropdown, IConfigurationDropdownProp, IDynamicDataToDialog, IItemDropdown } from 'src/app/core/interfaces/dropdown.models';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormControl, FormGroup } from '@angular/forms';
import { DataSetComponentService } from 'src/app/core/data/datasetcomponent-service';

@Component({
  standalone: false,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css']
})
export class DropdownComponent implements OnDestroy, OnChanges {
  @Input() dataToDialog!: IDynamicDataToDialog;
  @Input() className!: string;
  @Input() confProp!: IConfigurationDropdownProp;
  @Input() itemsProp!: IItemDropdown[];
  @Input() disabledProp: boolean = false;
  @Input() readonly: boolean = false;
  @Output() itemChanged = new EventEmitter<IChangeItemDropdown>();

  items: IItemDropdown[] = [];
  ref!: DynamicDialogRef;
  formItemDropdownGroup: FormGroup;
  disabledPropControl : boolean = false;
  classButtonControl : string = "";

  constructor(
    public dialogService: DialogService, 
    private datasetComponentService: DataSetComponentService
  )  {

    this.items = [];
    this.disabledPropControl = this.disabledProp;
    if (this.disabledPropControl) {
      this.classButtonControl = "width: 50px; right: 0";
    } else {
      this.classButtonControl = "width: 50px; right: 0";
    }
    this.formItemDropdownGroup = new FormGroup({
      itemFormControl: new FormControl({value : null , disabled : this.disabledProp})
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    for (let propName in changes) {
      if(propName === 'itemsProp'){
        this.items = changes[propName].currentValue;
        if(this.items.length > 0){
          this.formItemDropdownGroup.get("itemFormControl")?.patchValue(this.items[0].code);
        } else {
          this.formItemDropdownGroup.get("itemFormControl")?.patchValue(null);
        }
      }
      if(propName === 'disabledProp'){
        this.disabledProp = changes[propName].currentValue;
        if(this.disabledProp){
          this.formItemDropdownGroup.get("itemFormControl")?.disable();
        } else{
          this.formItemDropdownGroup.get("itemFormControl")?.enable();
        }
        this.disabledPropControl = this.disabledProp;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close();
    }
  }

  openDialog() {
    if (!this.disabledPropControl) {
      this.openDialogProcess();
    }
  }

  clearItems(){
    this.clearItemsProcess();
  }

  stopPropagation(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clearIconElement = target.closest('.p-dropdown-clear-icon');
    if (clearIconElement) {
      event.stopPropagation();
    }
  }

  private openDialogProcess(){

    const position = 'center';
    
      this.ref = this.dialogService.open(this.datasetComponentService.get(this.confProp.NameComponent), {
          width: '450px',
          header: this.confProp.Tooltip,
          closable: true,
          contentStyle: {"overflow": "auto"},
          position: position,
          dismissableMask: true,
          data: { dataToDialogArr: this.dataToDialog.Params, readonly: this.readonly  }
      }) as any;

      this.ref.onClose.subscribe((itemSel: IItemDropdown) => {
          if (itemSel) {
            this.items = [];
            itemSel.description = itemSel.description?.toUpperCase();
            this.items.push(itemSel);
            this.formItemDropdownGroup.get("itemFormControl")?.patchValue(itemSel.code);

            let _conf: IConfigurationDropdownProp = {
              Id: this.confProp.Id,
              Name: this.confProp.Name,
              Tooltip: this.confProp.Tooltip,
              NameComponent: this.confProp.NameComponent,
              Dataset: this.confProp.Dataset
            }
            let _data: IItemDropdown = {
              code: itemSel.code,
              description: itemSel.description,
              dataSerialize: itemSel.dataSerialize
            };
            let _itemChanged: IChangeItemDropdown = {
              conf: _conf,
              data: _data
            };
            this.itemChanged.emit(_itemChanged);

          }
      });
  }


  private clearItemsProcess(){

    this.items = [];

    let _conf: IConfigurationDropdownProp = {
      Id: this.confProp.Id,
      Name: this.confProp.Name,
      Tooltip: this.confProp.Tooltip,
      NameComponent: this.confProp.NameComponent,
      Dataset: this.confProp.Dataset
    }
    let _data: IItemDropdown = {
      code:'',
      description:'',
      dataSerialize: ''
    };
    let _itemChanged: IChangeItemDropdown = {
      conf: _conf,
      data: _data
    };
    this.itemChanged.emit(_itemChanged);
  }
}
